'use strict'

import css from './toolbar.styles.scss'
import template from './toolbar.template.pug'

export class ToolbarController {
  constructor($element, $scope, EyeCatcherService, $mdColors) {
    'ngInject'
    Object.assign(this, { $element, $scope, EyeCatcherService, $mdColors })
    this.css = css // Workaround for ng-class, see https://github.com/nkbt/ng-modular/blob/gh-pages/src/hello/hello.html
  }

  colors() {
    return {
      background: `primary-500-${this.EyeCatcherService.percent === 100 ? 1 : 0}`,
    }
  }

  /**
   * propagate toolbar height to eyecatcher service
   */
  $onInit() {
    this.$scope.$watch(
      () => this.$element[0].getBoundingClientRect().height,
      (height) => {
        this.EyeCatcherService.headerHeight = height
      },
    )
  }
}

export const umsToolbar = {
  template: template({}),
  transclude: true,
  controller: ToolbarController,
}



// WEBPACK FOOTER //
// ./app/shared/components/toolbar/toolbar.component.js